[
  {
    "inputs": [],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "authority",
        "type": "address"
      }
    ],
    "name": "AccessManagedInvalidAuthority",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "caller",
        "type": "address"
      },
      {
        "internalType": "uint32",
        "name": "delay",
        "type": "uint32"
      }
    ],
    "name": "AccessManagedRequiredDelay",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "caller",
        "type": "address"
      }
    ],
    "name": "AccessManagedUnauthorized",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "target",
        "type": "address"
      }
    ],
    "name": "AddressEmptyCode",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "AvatarContractAlreadySet",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "ECDSAInvalidSignature",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "length",
        "type": "uint256"
      }
    ],
    "name": "ECDSAInvalidSignatureLength",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "bytes32",
        "name": "s",
        "type": "bytes32"
      }
    ],
    "name": "ECDSAInvalidSignatureS",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "implementation",
        "type": "address"
      }
    ],
    "name": "ERC1967InvalidImplementation",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "ERC1967NonPayable",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "EmptyLabel",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "FailedInnerCall",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "uint16",
        "name": "background",
        "type": "uint16"
      }
    ],
    "name": "InvalidBackground",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "uint16",
        "name": "expression",
        "type": "uint16"
      }
    ],
    "name": "InvalidExpression",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "uint16",
        "name": "hairColor",
        "type": "uint16"
      }
    ],
    "name": "InvalidHairColor",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "uint16",
        "name": "hairStyle",
        "type": "uint16"
      }
    ],
    "name": "InvalidHairStyle",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidId",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidInitialization",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "uint32",
        "name": "nonce",
        "type": "uint32"
      }
    ],
    "name": "InvalidNonce",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "signer",
        "type": "address"
      }
    ],
    "name": "InvalidSignature",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "uint16",
        "name": "skinTone",
        "type": "uint16"
      }
    ],
    "name": "InvalidSkinTone",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NotInitializing",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "UUPSUnauthorizedCallContext",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "bytes32",
        "name": "slot",
        "type": "bytes32"
      }
    ],
    "name": "UUPSUnsupportedProxiableUUID",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "WearableContractAlreadySet",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "address",
        "name": "authority",
        "type": "address"
      }
    ],
    "name": "AuthorityUpdated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint64",
        "name": "version",
        "type": "uint64"
      }
    ],
    "name": "Initialized",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "implementation",
        "type": "address"
      }
    ],
    "name": "Upgraded",
    "type": "event"
  },
  {
    "inputs": [],
    "name": "UPGRADE_INTERFACE_VERSION",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "authority",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint16",
        "name": "background",
        "type": "uint16"
      }
    ],
    "name": "backgroundToString",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "backgrounds",
    "outputs": [
      {
        "internalType": "string[]",
        "name": "",
        "type": "string[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "backgroundsCount",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint16",
        "name": "expression",
        "type": "uint16"
      }
    ],
    "name": "expressionToString",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "expressions",
    "outputs": [
      {
        "internalType": "string[]",
        "name": "",
        "type": "string[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "expressionsCount",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getAvatarAddress",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getWearableAddress",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint16",
        "name": "hairColor",
        "type": "uint16"
      }
    ],
    "name": "hairColorToString",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "hairColors",
    "outputs": [
      {
        "internalType": "string[]",
        "name": "",
        "type": "string[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "hairColorsCount",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint16",
        "name": "hairStyle",
        "type": "uint16"
      }
    ],
    "name": "hairStyleToString",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "hairStyles",
    "outputs": [
      {
        "internalType": "string[]",
        "name": "",
        "type": "string[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "hairStylesCount",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "initialAuthority",
        "type": "address"
      }
    ],
    "name": "initialize",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "isConsumingScheduledOp",
    "outputs": [
      {
        "internalType": "bytes4",
        "name": "",
        "type": "bytes4"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "proxiableUUID",
    "outputs": [
      {
        "internalType": "bytes32",
        "name": "",
        "type": "bytes32"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "newAuthority",
        "type": "address"
      }
    ],
    "name": "setAuthority",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "contract Avatar",
        "name": "avatar_",
        "type": "address"
      }
    ],
    "name": "setAvatarContract",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint16",
        "name": "id",
        "type": "uint16"
      },
      {
        "internalType": "string",
        "name": "background",
        "type": "string"
      }
    ],
    "name": "setBackground",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint16",
        "name": "id",
        "type": "uint16"
      },
      {
        "internalType": "string",
        "name": "expression",
        "type": "string"
      }
    ],
    "name": "setExpression",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint16",
        "name": "id",
        "type": "uint16"
      },
      {
        "internalType": "string",
        "name": "hairColor",
        "type": "string"
      }
    ],
    "name": "setHairColor",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint16",
        "name": "id",
        "type": "uint16"
      },
      {
        "internalType": "string",
        "name": "hairStyle",
        "type": "string"
      }
    ],
    "name": "setHairStyle",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint16",
        "name": "id",
        "type": "uint16"
      },
      {
        "internalType": "string",
        "name": "skinTone",
        "type": "string"
      }
    ],
    "name": "setSkinTone",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "contract Wearable",
        "name": "wearable_",
        "type": "address"
      }
    ],
    "name": "setWearableContract",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint16",
        "name": "skinTone",
        "type": "uint16"
      }
    ],
    "name": "skinToneToString",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "skinTones",
    "outputs": [
      {
        "internalType": "string[]",
        "name": "",
        "type": "string[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "skinTonesCount",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "tokenURI",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "newImplementation",
        "type": "address"
      },
      {
        "internalType": "bytes",
        "name": "data",
        "type": "bytes"
      }
    ],
    "name": "upgradeToAndCall",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint16",
            "name": "expression",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "skinTone",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "hairColor",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "hairStyle",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "background",
            "type": "uint16"
          },
          {
            "internalType": "uint32",
            "name": "nonce",
            "type": "uint32"
          }
        ],
        "internalType": "struct AvatarMetadata.TokenMetadata",
        "name": "currentTokenMetadata",
        "type": "tuple"
      },
      {
        "components": [
          {
            "internalType": "uint16",
            "name": "expression",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "skinTone",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "hairColor",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "hairStyle",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "background",
            "type": "uint16"
          },
          {
            "internalType": "uint32",
            "name": "nonce",
            "type": "uint32"
          }
        ],
        "internalType": "struct AvatarMetadata.TokenMetadata",
        "name": "tokenMetadata",
        "type": "tuple"
      }
    ],
    "name": "validateMetadata",
    "outputs": [],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      },
      {
        "components": [
          {
            "internalType": "uint16",
            "name": "expression",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "skinTone",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "hairColor",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "hairStyle",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "background",
            "type": "uint16"
          },
          {
            "internalType": "uint32",
            "name": "nonce",
            "type": "uint32"
          }
        ],
        "internalType": "struct AvatarMetadata.TokenMetadata",
        "name": "currentTokenMetadata",
        "type": "tuple"
      },
      {
        "components": [
          {
            "internalType": "uint16",
            "name": "expression",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "skinTone",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "hairColor",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "hairStyle",
            "type": "uint16"
          },
          {
            "internalType": "uint16",
            "name": "background",
            "type": "uint16"
          },
          {
            "internalType": "uint32",
            "name": "nonce",
            "type": "uint32"
          }
        ],
        "internalType": "struct AvatarMetadata.TokenMetadata",
        "name": "tokenMetadata",
        "type": "tuple"
      },
      {
        "internalType": "bytes",
        "name": "signature",
        "type": "bytes"
      }
    ],
    "name": "validateMetadataSignature",
    "outputs": [],
    "stateMutability": "view",
    "type": "function"
  }
]
